import { settings, styling, steps } from '@components/Widgets/Templates/Base/_base'
import { maxWidth, type } from '@meta/widget/options'

const columnWidgetDefaultTemplate = {
  id: '',
  type: type.COLUMN,
  active: true,
  settings:
    (() => {
      return { ...settings }
    })(),
  styling: (() => {
    const customStyling = { ...styling }
    customStyling.maxWidth = maxWidth.SMALL

    return customStyling
  })(),
  steps: steps,
}

export default columnWidgetDefaultTemplate
